export { default } from "./AboutContent";
